import { ChatMessage, Tags } from "@risalabs_frontend_org/oasis-ui-kit";
import { useParams } from "react-router-dom";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import NoData from "../../../../components/noData/noData";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { useQueryCommentsData } from "./hooks/useQueryCommentsData";

const BASE_CLASS_NAME = "query-comments";

/**
 * Displays an ascending-chronological chat timeline of auth-status comments
 * (denials, queries, and query resolutions) for a single medical PA order.
 *
 * Renders three states: a loading indicator while comments are fetched,
 * a {@link NoData} empty state when none exist, and the chat timeline
 * otherwise.
 */
const QueryComments = () => {
  const { orderId } = useParams();
  const { chatMessages, loading } = useQueryCommentsData({
    orderId: orderId ?? "",
    orgId: getOrgIdForFetchExternalWorklist() ?? "",
  });

  if (loading) {
    return (
      <div
        className={`${BASE_CLASS_NAME}-loading-container flex h-full w-full items-center justify-center`}
      >
        <LoaderMessage message="Loading comments..." />
      </div>
    );
  }

  if (chatMessages.length === 0) {
    return (
      <div
        className={`${BASE_CLASS_NAME}-empty-container flex h-full w-full items-center justify-center rounded-lg border border-primaryGray-14 p-4`}
      >
        <NoData text="No Comments Found" />
      </div>
    );
  }

  return (
    <div
      className={`${BASE_CLASS_NAME} flex h-full flex-col gap-6 overflow-auto rounded-lg border border-primaryGray-14 p-4`}
    >
      {chatMessages.map((message) => (
        <ChatMessage
          avatarLabel={message.avatarLabel}
          maxWidth="32rem"
          message={message.message}
          senderName={message.senderName}
          side="left"
          timestamp={message.timestamp}
          bubbleClassName="bg-[#F7F9FA] rounded border-[0px] text-tiny text-primaryGray-4"
          metaAction={
            <>
              <Tags
                label={message.tagLabel}
                options={[]}
                backgroundColor={message.tagBackgroundColor}
                textColor={message.tagForeGroundColor}
              />
            </>
          }
        />
      ))}
    </div>
  );
};

export default QueryComments;
